module.exports = __webpack_public_path__ + "static/media/817NorthAvenueNW_2018-07-09_151.5729ac11.jpg";